// IntegrationSpecificAdminSettings.tsx
import { IntegrationServiceId } from '../../../../common/integrations'
import { useCustomizableAdminSettings } from './CustomizableAdminSettings'
import { useMemo } from 'react'
import { usePredefinedAdminSettings } from './PredefinedAdminSettings'

export const useIntegrationSpecificAdminSections = (serviceId: IntegrationServiceId) => {
  const customizableSections = useCustomizableAdminSettings(serviceId)

  const predefinedSections = usePredefinedAdminSettings(serviceId)

  return useMemo(() => {
    switch (serviceId) {
      case IntegrationServiceId.SALESFORCE:
      case IntegrationServiceId.PRACTIFI:
      case IntegrationServiceId.XLR8:
      case IntegrationServiceId.BLACK_DIAMOND:
      case IntegrationServiceId.ELEMENTS:
      case IntegrationServiceId.DYNAMICS:
      case IntegrationServiceId.ENGAGE:
        return customizableSections
      case IntegrationServiceId.REDTAIL:
      case IntegrationServiceId.WEALTHBOX:
      case IntegrationServiceId.ZOHO:
        return predefinedSections
      default:
        return []
    }
  }, [serviceId, customizableSections, predefinedSections])
}
